import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import InsureYourCarWrapper from "@components/layouts/insureYourCarWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <InsureYourCarWrapper>
            <TermsAndConditions className="max-w-7xl mx-auto" />
        </InsureYourCarWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
